export const setCameraPosition = function(position){
  this.camera.position.x = position.x;
  this.camera.position.y = position.y;
  this.camera.position.z = position.z;
  this.controls.orbitControl.update();
  this.render();
};
